import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import { BellRing, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function BundleInterestDialog({ bundle, triggerClassName, triggerLabel = "Register interest" }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", email: "" });
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email) { toast.error("Please enter your name and email."); return; }
    setSubmitting(true);
    try {
      await api.post("/enquiries", {
        type: "Workshop", name: form.name, email: form.email,
        context: `${bundle.title}${bundle.price ? ` ($${bundle.price})` : ""}`,
        message: `Interested in ${bundle.title}. Please notify me when it is released.`,
      });
      toast.success("Interest registered — we'll email you as soon as dates are released.");
      setForm({ name: "", email: "" });
      setOpen(false);
    } catch { toast.error("Something went wrong. Please try again."); }
    finally { setSubmitting(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className={triggerClassName} data-testid={`bundle-interest-${bundle.id}`}>
          <BellRing className="w-4 h-4" /> {triggerLabel}
        </Button>
      </DialogTrigger>
      <DialogContent data-testid="bundle-interest-dialog">
        <DialogHeader><DialogTitle className="font-display">{bundle.title}</DialogTitle></DialogHeader>
        <DialogDescription className="text-sm text-slate-600 -mt-2">
          Register your interest and we'll let you know first when dates are confirmed. No payment required.
        </DialogDescription>
        <form onSubmit={submit} className="space-y-4 mt-2">
          <div>
            <Label htmlFor={`bi-name-${bundle.id}`}>Full name</Label>
            <Input id={`bi-name-${bundle.id}`} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1.5" data-testid="bundle-interest-name" />
          </div>
          <div>
            <Label htmlFor={`bi-email-${bundle.id}`}>Email</Label>
            <Input id={`bi-email-${bundle.id}`} type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1.5" data-testid="bundle-interest-email" />
          </div>
          <Button type="submit" disabled={submitting} className="w-full bg-teal-600 hover:bg-teal-700 rounded-full" data-testid="bundle-interest-submit">
            {submitting ? <Loader2 className="w-4 h-4 animate-spin" /> : "Register my interest"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
